<!--
 * @Description:上传附件-活动列表
 * @Date: 2023/4/20 下午3:41:37
-->
<template>
  <base-dialog
    :visible="true"
    :model-value="true"
    :show-close="true"
    :close-on-press-escape="true"
    :close-on-click-modal="false"
    title="上传附件"
    width="420px"
  >
    <div style="margin: 0 auto; padding: 30px">
      <base-form
        ref="formRef"
        :model="form"
        label-width="auto"
        label-position="right"
      >
        <base-form-item
          :rules="[{ required: true, message: '文件夹名称不能为空' }]"
          label="文件夹名称："
          prop="folderName"
        >
          <base-input
            v-model="form.folderName"
            placeholder="请输入文件夹名称"
            maxlength="30"
            :show-word-limit="true"
          />
        </base-form-item>
        <base-form-item label="" prop="">
          <div>
            <BaseUpload
              ref="upload"
              v-model:fileList="fileList"
              style="width: 360px"
              :http-request="httpRequest"
              :auto-upload="true"
              :multiple="false"
              :accept="[
                '.xls',
                '.xlsx',
                '.zip',
                '.doc',
                '.docx',
                '.ppt',
                '.pptx',
                '.pdf',
                '.png',
                '.jpg'
              ]"
              :limit="6"
              :limit-size="60"
              :drag="true"
              :onError="onError"
              btnText="点击上传"
            >
              <template #tip>
                支持上传zip、xls、xlsx、doc、docx、ppt、pptx、pdf、png、jpg格式文件，且不超过60M。
              </template>
            </BaseUpload>
          </div>
        </base-form-item>
      </base-form>
    </div>
    <template #footer>
      <BaseButton @click="onCancel" type="default">取消</BaseButton>
      <BaseButton :click="onConfirm" type="primary">确认</BaseButton>
    </template>
  </base-dialog>
</template>
<script lang="tsx" setup>
import { defineProps, withDefaults, reactive, ref, defineEmits } from 'vue';
import {
  BaseButton,
  BaseDialog,
  BaseForm,
  BaseFormItem,
  BaseFormRef,
  BaseUpload,
  XrkMessage,
  BaseInput
} from 'xrk-components';
import { uploadApi } from '@data-source/common/apis';
import { activityDetail, uploadActivityFile } from '../data-source/apis';

// 表单实例
const formRef = ref<BaseFormRef>(null);
// upload上传
const upload = ref(null);
const fileList = ref([]);
// 声明 prop 属性
const props = withDefaults(
  defineProps<{
    remove?: () => {};
    activityId: number;
  }>(),
  {
    remove() {
      return () => ({});
    },
    activityId: null
  }
);
const emits = defineEmits(['success']);

const form = reactive<{
  folderName: string; //文件夹名称
}>({
  folderName: ''
});

const httpRequest = ({ file }) => {
  return uploadApi({ file });
};
const onError = errorInfo => {
  XrkMessage.error(errorInfo.msg);
};
const onCancel = () => {
  props.remove();
};

const initData = async () => {
  const { data } = await activityDetail({ activityId: props.activityId });
  form.folderName = data.folderName;
  fileList.value = data.fileList.map(item => {
    return {
      name: item.fileName,
      url: item.fileUrl
    };
  });
};
initData();

const onConfirm = async () => {
  await formRef.value.validate();
  if (!fileList.value.length) {
    XrkMessage.error('请上传文件！');
    return;
  }
  await uploadActivityFile({
    activityId: props.activityId,
    folderName: form.folderName,
    activityAttachmentInDTO: fileList.value.map(item => {
      return {
        activityId: props.activityId,
        fileName: item.name,
        fileUrl: item.url
      };
    })
  });
  emits('success');
};
</script>
